import { create } from 'zustand';

const useMapStateStore = create((set) => ({
  // State
  activeZoom: null,
  effectiveMaxZoom: null, // Max zoom available at current location (from Google MaxZoomService)
  activeLevelSvgId: null,
  initialLevelSvgId: null,
  activeMapType: 'roadmap',
  POIVisible: false,
  resetMap: false,
  svgFocusId: null,
  pendingAmenityModal: false,
  focusAnimationComplete: false,
  hasPendingResidenceFocus: false,
  amenityModalOpen: false,
  // TGAI sliding-panel open state. Lifted from TourGuideAi's local
  // useState so the on-map ChatbotControl can toggle the panel too.
  tgaiPanelOpen: false,
  // Place uuids currently covered by an expanded zoom-zone label. The zone
  // MapLabels instance publishes; the place MapLabels instance reads from
  // MapPlaceLabel so the covered labels hide and re-render as a single
  // overflow cluster badge. Cross-tree communication channel.
  coveredPlaceUuids: new Set(),
  // Cluster-id → extra uuids absorbed from a zoom-zone overflow. When the
  // zone's covered place labels can be folded into an existing place cluster
  // for the same building, the standalone overflow badge is suppressed and
  // the cluster's "N More" count is bumped instead.
  clusterBoosts: new Map(),

  // Actions
  setActiveZoom: (activeZoom) => set({ activeZoom }),
  setEffectiveMaxZoom: (effectiveMaxZoom) => set({ effectiveMaxZoom }),
  setActiveLevelSvgId: (activeLevelSvgId) => set({ activeLevelSvgId }),
  setInitialLevelSvgId: (initialLevelSvgId) => set({ initialLevelSvgId }),
  setActiveMapType: (activeMapType) => set({ activeMapType }),
  setPOIVisible: (POIVisible) => set({ POIVisible }),
  setResetMap: (resetMap) => set({ resetMap }),
  setSvgFocusId: (svgFocusId) => set({ svgFocusId }),
  setPendingAmenityModal: (pendingAmenityModal) => set({ pendingAmenityModal }),
  setFocusAnimationComplete: (focusAnimationComplete) => set({ focusAnimationComplete }),
  setHasPendingResidenceFocus: (hasPendingResidenceFocus) => set({ hasPendingResidenceFocus }),
  setAmenityModalOpen: (amenityModalOpen) => set({ amenityModalOpen }),
  setTgaiPanelOpen: (tgaiPanelOpen) => set((state) => ({
    tgaiPanelOpen: typeof tgaiPanelOpen === 'function'
      ? tgaiPanelOpen(state.tgaiPanelOpen)
      : tgaiPanelOpen,
  })),
  setCoveredPlaceUuids: (coveredPlaceUuids) => set({ coveredPlaceUuids }),
  setClusterBoosts: (clusterBoosts) => set({ clusterBoosts }),
}));

export default useMapStateStore;
